import { AbstractSettings, AbstractSettingsDef } from "./AbstractSettings";
import { SettingsRegistry } from "./SettingsRegistry";

export interface CompanySettingsDef extends AbstractSettingsDef {

    //unauth
    allow_keep_signed_in: boolean;
    enable_phone_format: boolean;
    header_bg_color: string;
    header_logo: string; // base64
    id: string;
    is_multi_currency: boolean;
    name: string;
    phone_format: string;
    text_color: string;
    scac: string;
    company_type: string;

    //auth
    earliest_pickup: Date;
    is_asset: boolean;
    is_asset_ltl: boolean;
    is_brokerage: boolean;
    is_brokerage_ltl: boolean;
    is_brokerage_only: boolean;
    is_ltl: boolean;
    ltl_max_weight: number;
    order_contact_name: string;
    order_contact_phone: string;
    ord_latest_pickup_time: Date;
    carrier_user_group: string;
    customer_user_group: string;
    driver_user_group: string;
    location_user_group: string;
    enable_dd_encryption: boolean;
    enable_transferlog: boolean;
    default_weight_uom: string; //LB or KG
    commission_enabled: boolean;
    company_alias_name: string;
    intercompany_main_company: boolean;

    //dispatch_control
    ltl_freight_dimension_uom: string;
    enforce_shipper_id: boolean;
    enforce_credit: string;
    partial_shipment_enabled: boolean;
    creation_manifest_on_hold: boolean;
    comparative_option_rating: boolean;
    partial_shipment_licensed: boolean;
}

export class CompanySettings extends AbstractSettings {
    constructor() {
        super("company_settings");
    }

    public static getSingleton(): CompanySettings {
        return SettingsRegistry.get().getObject("company_settings") as CompanySettings;
    }

    public static get(): CompanySettingsDef {
        return CompanySettings.getSingleton()?.values as CompanySettingsDef;
    }

    public override get values(): CompanySettingsDef {
        return super.values as CompanySettingsDef;
    }

    protected getValuesInternal(): CompanySettingsDef {
        return this._values as CompanySettingsDef;
    }

    public isAsset(): boolean {
        return this.getValuesInternal()?.is_asset === true;
    }

    public isAssetLtl(): boolean {
        return this.getValuesInternal()?.is_asset_ltl === true;
    }

    public isBrokerage(): boolean {
        return this.getValuesInternal()?.is_brokerage === true;
    }

    public isBrokerageLtl(): boolean {
        return this.getValuesInternal()?.is_brokerage_ltl === true;
    }

    public isBrokerageOnly(): boolean {
        return this.getValuesInternal()?.is_brokerage_only === true;
    }

    public isLtl(): boolean {
        return this.getValuesInternal()?.is_ltl === true;
    }

    public isProcessLogEnabled(): boolean {
        return this.getValuesInternal()?.enable_transferlog === true;
    }

    public isIntercompanyMainCompany(): boolean {
        return this.getValuesInternal()?.intercompany_main_company === true;
    }

    public isBoth(): boolean {
        return this.getValuesInternal()?.is_asset === true && this.getValuesInternal()?.is_brokerage === true;
    }

}
